export default __webpack_public_path__ + "static/media/default_profile.98915593.png";